export { PickerMode } from './_core/control-value';
export type { DateRangeValue, DatePickerValue } from './_core/control-value';

/**
 * How the user is allowed to enter a value. `both` by default; a disabled control
 * blocks both paths regardless.
 */
export const DatePickerEntry = { Both: 'both', Input: 'input', Picker: 'picker' } as const;
export type DatePickerEntry = (typeof DatePickerEntry)[keyof typeof DatePickerEntry];

export type DatePickerSize = 'small' | 'large';

/** Mirrors the old `autocompleteTimeMode`: fills a blank time with the edge of the day. */
export const DatePickerAutocomplete = { From: 'from', To: 'to' } as const;
export type DatePickerAutocomplete =
  (typeof DatePickerAutocomplete)[keyof typeof DatePickerAutocomplete];
